import { render, staticRenderFns } from "./productGroupOrderTable.vue?vue&type=template&id=c2b8da52&scoped=true"
import script from "./productGroupOrderTable.vue?vue&type=script&lang=js"
export * from "./productGroupOrderTable.vue?vue&type=script&lang=js"
import style0 from "./productGroupOrderTable.vue?vue&type=style&index=0&id=c2b8da52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8da52",
  null
  
)

export default component.exports